import { useLocation, Link } from 'react-router-dom';

interface Props {
  unreadCount?: number;
}

const NAV_ITEMS = [
  { to: '/',             icon: 'floor_plan',  label: 'Tables' },
  { to: '/orders',        icon: 'receipt_long', label: 'Orders' },
  { to: '/kds',           icon: 'restaurant',   label: 'KDS' },
  { to: '/notifications', icon: 'campaign',    label: 'Notifs' },
  { to: '/shift',         icon: 'bar_chart',   label: 'Mon shift' },
];

export default function BottomNav({ unreadCount = 0 }: Props) {
  const { pathname } = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-surface flex staff-bottom-nav-safe"
      style={{ borderTop: '0.5px solid #e5e7eb', height: 60 }}
    >
      {NAV_ITEMS.map((item) => {
        const active = pathname === item.to || (item.to !== '/' && pathname.startsWith(item.to));
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[48px] relative ${
              active ? 'text-primary' : 'text-on-surface-variant'
            }`}
          >
            <span className="material-symbols-outlined text-[22px]">{item.icon}</span>
            <span className="text-[10px] font-semibold uppercase tracking-wider">{item.label}</span>
            {item.icon === 'campaign' && unreadCount > 0 && (
              <span className="absolute top-1 right-[calc(50%-14px)] w-4 h-4 rounded-full bg-error text-on-error text-[9px] font-bold flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}
